import { useEffect, useState } from 'react';
import { CheckCircle2, AlertTriangle, Info, X } from 'lucide-react';
let listeners = [];
let counter = 0;
let notificationsEnabled = true;

export function setToastNotificationsEnabled(enabled) {
  notificationsEnabled = enabled !== false;
}

/** Fire a toast from anywhere: toast('Saved!', 'success') */
export function toast(message, type = 'info', duration = 3800) {
  if (!notificationsEnabled) return;

  const item = { id: ++counter, message, type, duration };
  listeners.forEach((l) => l(item));
}

const ICONS = {
  success: CheckCircle2,
  error: AlertTriangle,
  info: Info,
};

function Toaster() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const add = (item) => {
      setItems((prev) => [...prev, item]);
      if (item.duration > 0) {
        setTimeout(() => setItems((prev) => prev.filter((x) => x.id !== item.id)), item.duration);
      }
    };
    listeners.push(add);
    return () => {
      listeners = listeners.filter((l) => l !== add);
    };
  }, []);

  const dismiss = (id) => setItems((prev) => prev.filter((x) => x.id !== id));

  return (
    <div className="toaster">
      {items.map((t) => {
        const Icon = ICONS[t.type] || Info;
        return (
          <div key={t.id} className={`toast toast-${t.type}`} role={t.type === 'error' ? 'alert' : 'status'} aria-live={t.type === 'error' ? 'assertive' : 'polite'}>
            <Icon size={17} className="toast-icon" />
            <span className="toast-msg">{t.message}</span>
            <button className="toast-close" onClick={() => dismiss(t.id)} aria-label="Dismiss"><X size={14} /></button>
          </div>
        );
      })}
    </div>
  );
}

export default Toaster;
